import { render } from "./SpAppAlert.vue?vue&type=template&id=053ddaca&scoped=true"
import script from "./SpAppAlert.vue?vue&type=script&lang=js"
export * from "./SpAppAlert.vue?vue&type=script&lang=js"

import "./SpAppAlert.vue?vue&type=style&index=0&id=053ddaca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-053ddaca"]])

export default __exports__